import { Injectable } from '@angular/core';
import { PublicIssueType } from '../enums/public-issue-type';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class PublicIssueTypeProviderService {
  private readonly entries = new Map<PublicIssueType, string>([
    [PublicIssueType.Issue, 'Zgłoszenie / Zapytanie'],
    [PublicIssueType.Complaint, 'Reklamacja'],
  ]);

  public labelFor(type: PublicIssueType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" is not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<PublicIssueType>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([type, label]) => new SelectItem(label, type),
    );

    return of(result);
  }
}
